// CSS styles
export const tooltipStyles = {
  backgroundColor: "#181A1C",
  borderWidth: 2,
  // borderColor: "#49505C",
  borderColor: "#BDBDBD",
  padding: '10px',
  outline: "none",
  borderRadius: 8
};